import { useContext, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Tabs from '../../components/Common/Tabs';
import { UserContext } from '../../contexts/UserContext';

export default function ManageDynamicPageSettings() {
  const location = useLocation();
  const navigate = useNavigate();

  const { selectedAccount } = useContext(UserContext);

  const googleAdsAccountConnected = useMemo(
    () => selectedAccount?.data().googleAdsAccountConnected,
    [selectedAccount],
  );

  const subTabs = useMemo(() => {
    const currentTab = location.pathname.split('/').pop();
    return [
      {
        id: 'general',
        name: 'General',
        current: false,
      },
      {
        id: 'tracking',
        name: 'Tracking & URL Settings',
        current: false,
      },
      ...(googleAdsAccountConnected
        ? [
            {
              id: 'ad-account',
              name: 'Ad Account',
              current: false,
            },
          ]
        : []),
      {
        id: 'custom-code',
        name: 'Custom Code',
        current: false,
      },
      {
        id: 'seo',
        name: 'SEO',
        current: false,
      },
      {
        id: 'design',
        name: 'Design',
        current: false,
      },
      {
        id: 'integrations',
        name: 'Integrations',
        current: false,
      },
    ].map((c) => {
      c.current = c.id === currentTab;
      return c;
    });
  }, [location.pathname, googleAdsAccountConnected]);

  return (
    <div>
      <div className="sticky top-0 w-full bg-white">
        <Tabs
          className=""
          tabs={subTabs}
          onTabClick={(id) => {
            navigate(`./${id}`);
          }}
        />
      </div>

      <div className="px-0 py-6">
        <div className="px-4 sm:px-6 lg:flex-auto lg:px-0">
          <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
